export function checkImage(name: string) {
  //HACK replace with actual function for this
  return ["apng", "gif", "jpeg", "jpg", "png", "svg", "webp"].includes(
    name.split(".")[1]
  );
}

export function isAllTruthy(...props: any) {
  return [...props].every(Boolean);
}

export function getFormattedStringDate(date: Date) {
  return `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
}

export function randomizeFileName(name: string) {
  return `${Date.now()}_${name}`;
}
